<template>
  <section class="row">
    <div class="col-12">
      <div class="card">
        <div
          class="card-body px-md-4 py-md-5 rounded-4 py-4 transition-shadow
            box-shadow-yellow-300 box-shadow-hover-yellow-300"
        >
          <div class="row">
            <div class="col-2">
              <v-icon
                icon="chevron-left"
                class="cursor-pointer"
                @click="() => $router.back()"
              />
            </div>
            <div class="col-8 d-flex flex-column">
              <div class="h5 text-center mb-3">
                Vos cartes bancaires
              </div>
            </div>
            <div class="col-12 col-md-10 mx-auto">
              <p>
                Vous pouvez choisir votre carte principale en modifiant l’ordre ci-dessous.
                Pour cela, cliquez sur une carte et glissez-la vers le haut ou vers le bas
                pour modifier l’ordre de priorité.
              </p>
              <div class="d-flex mx-auto mb-3">
                <img
                  v-if="creditCards.length === 0"
                  :src="`${aws}/unicorn-magnifying-glass.png`"
                  alt="Assurup image loupe"
                  class="img-fluid mx-auto"
                >
              </div>
            </div>
            <div
              class="col-12 col-md-10 mx-auto"
              :class="{ 'my-4': creditCards.length > 0 }"
            >
              <transition-group name="flip-list">
                <v-credit-card-display
                  v-for="creditCard in creditCards"
                  :key="creditCard.id"
                  :credit-card="creditCard"
                  class="mb-3"
                  @error="(value) => error = value"
                />
              </transition-group>
            </div>
            <div class="col-12 col-md-10 mx-auto">
              <v-loader
                :next="() => $router.push('/client/account/payments/credit-cards/add')"
                title="Ajouter une nouvelle carte bancaire"
                icon="plus-white"
                class="w-100"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import CreditCardDisplay from '../helpers/CreditCardDisplay.vue';

export default {
  name: 'AccountPaymentCard',
  components: {
    'v-credit-card-display': CreditCardDisplay,
  },
  computed: {
    creditCards() {
      const cards = this.$store.getters['payments/paymentMethods']
        .filter(({ type }) => type === 'CARD')
        || [];
      return [...cards].sort(({ active: a }, { active: b }) => +b - +a);
    },
    activeCreditCard() {
      return this.creditCards.find(({ active }) => active);
    },
    aws: () => `${import.meta.env.VITE_AWS_STATIC}/common/png`,
  },
  mounted() {
    this.$store.dispatch('payments/getPaymentMethods');
  },
};
</script>
<style scoped>
.flip-list-move {
  transition: transform 1s;
}
</style>
